module.exports = __webpack_public_path__ + "img/2.5508b511.png";